<div style="display: flex;">
    <!-- The esa-material-button does not play nice with AG Grid; need to use a regular button element -->
    <button *ngIf="editMode" (click)="onClick()"><mat-icon>edit</mat-icon></button>
    <span style="padding-left: 4px;">{{ displayValue }}</span>
</div>

